import constants from '../../../common/constants';

export const formatPrice = (value, name, country) => {
  if (!value || !name) return '';

  const currency = value || value === 0 ? (country === constants.COUNTRIES.england.code ? constants.CURRENCIES.gbp.name : constants.CURRENCIES.sek.name) : '';

  return currency;
};
